import { User } from 'firebase/auth';
import React from 'react';
import { NavigateProps } from 'react-router';
import { Navigate, Outlet } from 'react-router-dom';
import AdminOutlet from './admin/AdminOutlet';
import BookingsPage from './admin/booking/BookingsPage';
import BusinessCreationPage from './admin/booking/BusinessCreationPage';
import DialogPage from './admin/event-creation/DialogPage';
import EventCreationFuturePage from './admin/event-creation/EventCreationFuturePage';
import EventPage from './admin/event-creation/EventPage';
import EventsPage from './admin/event-creation/EventsPage';
import IndicatorPage from './admin/event-creation/InidicatorPage';
import HouseManagerScreen from './admin/house-manager/HouseManagerScreen';
import DashboardPage from './admin/pocket-scout/dashboard/DashboardPage';
import OrderCreationPage from './admin/pocket-scout/order-creation/OrderCreationPage';
import SignInScreen from './auth/SignInScreen';


function WrapNavigate(props: NavigateProps & { id: string }) {
  console.log(props.id, 'Redirecting to...', props.to);
  return (
    <Navigate {...props}/>
  );
}

const routes = (user: User | null, isAdmin: boolean) => {
  console.log(user, isAdmin);
  return [
    {
      path: '/',
      element: <Outlet/>,
      children: [
        {
          path: 'admin',
          element: !!user && !user.isAnonymous && isAdmin ? <AdminOutlet/> : <SignInScreen defaultRedirect="/admin"/>,
          children: [
            {
              path: 'events', element: <Outlet/>, children: [
                { path: 'select', element: <EventsPage/> },
                { path: 'future', element: <EventCreationFuturePage/> },
                {
                  path: 'event', element: <Outlet/>, children: [
                    { path: ':event', element: <EventPage/> }
                  ]
                },
                {
                  path: 'indicator', element: <Outlet/>, children: [
                    {
                      path: ':event', element: <Outlet/>, children: [
                        { path: ':indicator', element: <IndicatorPage/> }
                      ]
                    }
                  ]
                },
                {
                  path: 'dialog', element: <Outlet/>, children: [
                    {
                      path: ':event', element: <Outlet/>, children: [
                        { path: ':indicator', element: <DialogPage/> }
                      ]
                    }
                  ]
                },
                { path: '', element: <WrapNavigate to={'/admin/events/select'} id="/admin/events/*"/> }
              ]
            },
            {
              path: 'booking', element: <Outlet/>, children: [
                { path: 'select', element: <BookingsPage/> },
                { path: 'business-create', element: <BusinessCreationPage/> },
                { path: '', element: <WrapNavigate id="/admin/booking/*" to="/admin/booking/select"/> }
              ]
            },
            {
              path: 'scout', element: <Outlet/>, children: [
                { path: 'dashboard', element: <DashboardPage/> },
                {
                  path: 'order-creation', element: <Outlet/>, children: [
                    { path: ':uid', element: <OrderCreationPage/> }
                  ]
                },
                { path: '', element: <WrapNavigate id="/admin/scout/*" to="/admin/scout/dashboard"/> }
              ]
            },
            {
              path: 'wh', element: <Outlet/>, children: [
                { path: 'dashboard', element: <HouseManagerScreen/> },
                { path: '', element: <WrapNavigate id="/admin/wh/*" to="/admin/wh/dashboard"/> }
              ]
            },
            { path: '', element: <WrapNavigate id="/admin/*" to="/admin/wh"/> }
          ]
        },
        {
          path: 'signin',
          element: <SignInScreen defaultRedirect="/admin"/>
        },
        // { path: '', element: <WrapNavigate id="/*" to="/welcome?signinRedirect=/app/home"/> },
        { path: '', element: <WrapNavigate id="/*" to="/admin"/> }
      ]
    },
    {
      path: '',
      element: <WrapNavigate id="/*" to="/admin"/>
    }
  ];
};

export default routes;
